import React, { useCallback, useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import DOMPurify from "dompurify";
import _ from "lodash";
import {
  Button,
  Card,
  Col,
  Dropdown,
  Form,
  Nav,
  NavDropdown,
  OverlayTrigger,
  Row,
  Spinner,
  Tab,
  Tabs,
  Tooltip,
} from "react-bootstrap";
import { BsDownload, BsFillEyeFill } from "react-icons/bs";
import { CgUndo } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import CNPJ from "../../../components/Formatters/CNPJ";
import CPF from "../../../components/Formatters/CPF";
import { formatarData } from "../../../components/Formatters/DateTime";
import IE from "../../../components/Formatters/IE";
import FileDownloader from "../../../components/UI/Button/FileDownloader";
import FormAlert from "../../../components/UI/FormAlert/FormAlert";
import { AuthContext } from "../../../context/AuthContext";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import { signalrActions } from "../../../redux/signalr";
import AlteracaoExecutorOs from "../AlteracaoExecutorOs/AlteracaoExecutorOs";
import AndamentoOs from "../AndamentoOs";
import ConsultaAnexos from "../Anexos/ConsultaAnexos";
import InputsProximaAtividadeBase from "../InputsProximaAtividade/InputsProximaAtividadeBase";
import ProrrogacaoOs from "../ProrrogacaoOS/ProrrogacaoOS";
import ButtonImage from "../../../components/UI/Button/ButtonImage";
import useGerarDemonstrativoOcorrenciaSigat from "./hooks/useGerarDemonstrativoOcorrenciaSigat";
import OutrasAcoesFiscais from "../OutrasAcoesFiscais/OutrasAcoesFiscais";
import AutoInfracaoEspecial from "../AutoInfracaoEspecial/AutoInfracaoEspecial";
import TSPS from "../TSPS/tsps";
import ConsultaOcorrenciaAF from "../Ocorrencias/ConsultaOcorrenciaAF";
import ParteServicoOs from "../ParteServico/ParteServicoOs";
import PatExistente from "../PATExistente/PATExistente";
import EfisModal from "../../../components/UI/EfisModal/EfisModal";
import ConsultaContribuinte from "../ConsultaContribuinte";
import ConsultaSped from "../Sped/components/ConsultaSped";
import ExtratoFiscal from "../ExtratoFiscal/ExtratoFiscal";
import useDocumentoSpf from "../../SPF/hooks/useDocumentoSpf";
import ConsultaRefc from "../REFC/components/ConsultaRefc";
import ParteServicoPaginatedView from "../../../components/UI/PaginatedView/ParteServicoPaginatedView";
import useColumns from "../ParteServico/hooks/useColumns";
import useExcluirParteServicoOs from "../ParteServico/hooks/useExcluirParteServicoOs";
import useEncerrarParteServicoOs from "../ParteServico/hooks/useEncerrarParteServicoOs";
import useAndamentoDesignaDocumento from "../AndamentoOS/hooks/useAndamentoDesignaDocumento";

const documentoSpf = { exibir: () => {} };
const andamentoDesignaDoc = { exibir: () => {} };

const exibirDocumento = (dadosSpf) => {
  documentoSpf.exibir(dadosSpf);
};

const validationSchema = Yup.object().shape({
  sequencial: Yup.string().default(""),
  dataInicialPeriodoOs: Yup.date(),
  dataFinalPeriodoOs: Yup.date(),
  dataInicialFiscalizacao: Yup.date(),
  dataFinalFiscalizacao: Yup.date(),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const demonstrativoOcorrenciasSigat = { exibir: () => {} };

const ConsultaDadosOs = ({ location, history }) => {
  const [key, setKey] = useState("1.0");
  const handleSelect = (eventKey) => {
    setKey(eventKey);
  };
  const [show, setShow] = useState(false);
  const [sequencialOs] = useState(location?.state?.itemKey);
  const { filaAssinaturaSucessoStateKey } = useSelector((state) => state.signalr);
  const dispatch = useDispatch();

  const { isAllowed } = useContext(AuthContext);
  const [dados, setDados] = useState({});
  const [cnpjCpf, setCnpjCpf] = useState("");
  const [executores, setExecutores] = useState("");
  const [dataInicialFiscalizacao, setDataInicialFiscalizacao] = useState("");
  const [dataFinalFiscalizacao, setDataFinalFiscalizacao] = useState("");
  const [dataInicialPeriodoOs, setDataInicialPeriodoOs] = useState("");
  const [dataFinalPeriodoOs, setDataFinalPeriodoOs] = useState("");
  const [diasParaExpirar, setDiasParaExpirar] = useState("");
  const [dataUltimaAtividadeExecutada, setDataUltimaAtividadeExecutada] = useState("");
  const [anexos, setAnexos] = useState([]);
  const [ehInativoDte, setEhInativoDte] = useState("");
  const [ehInativo, setEhInativo] = useState("");
  const [mostrarNumAuto, setMostrarNumAuto] = useState(false);
  const [produtosAcaoFiscal, setProdutosAcaoFiscal] = useState([]);
  const [consultarOs] = useState(history?.location?.pathname === "/app/os/consultarOs/consulta" ? 1 : 0);
  const [showModal, setShowModal] = useState(false);
  const [textoCancelamento, setTextoCancelamento] = useState("");
  let texto = "";

  const { request: requestInativoDte, data: dataInativoDte } = useApiClient();
  const { request: requestInativo, data: dataInativo } = useApiClient();

  const { setDemonstrativoParams } = useGerarDemonstrativoOcorrenciaSigat();
  demonstrativoOcorrenciasSigat.exibir = (dadosUser, dadosOs, ocorrencia) => {
    setDemonstrativoParams({
      sqAcaoFiscal: dadosOs.acaoFiscal,
      sqProdutoAFiscal: "",
      sqPessoa: dadosOs.sequencialPessoa,
      tpProduto: "A",
      autoEspecial: "",
      sqItemOcorrencia: ocorrencia.sequencial,
      numOrdemOcorrencia: ocorrencia.sequencialLinha,
      notificacao: "",
    });
  };

  const { request: requestForm, data: dataForm, errors: errorForm, isLoading } = useApiClient();
  const {
    request: cancelarRequest,
    data: cancelarData,
    errors: cancelarErrors,
    isLoading: cancelarIsLoading,
  } = useApiClient();

  const handleSubmit = useCallback(
    (values) => {
      requestForm(apiRoutes.fiscalizacao.ordemservico.inserirOs, values);
    },
    [requestForm],
  );

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  const { setSubmitting, setErrors, isSubmitting, isValid } = formik;

  const { verificaPsExcluir } = useExcluirParteServicoOs({ formik });
  const { verificaPs } = useEncerrarParteServicoOs({ formik });
  const { columns } = useColumns({ verificaPs, verificaPsExcluir, origem: "dossie" });

  useEffect(() => {
    if ((dataForm || errorForm) && isSubmitting && !isLoading) formik.setSubmitting(false);

    if (errorForm && isValid && !isLoading) formik.setErrors({ ...formik.errors, ...errorForm });
  }, [formik, setSubmitting, setErrors, isSubmitting, isValid, dataForm, errorForm, isLoading]);

  useEffect(() => {
    if (!dataForm && !errorForm) return;

    if (dataForm) {
      toast.success(dataForm.result);
      history.push("/app/os/executarOs");
    }
  }, [dataForm, errorForm, history]);

  const [proximasAtividades, setProximasAtividades] = useState([]);
  const {
    request: proximasAtividadesRequest,
    data: proximasAtividadesData,
    errors: proximasAtividadesErrors,
  } = useApiClient();

  useEffect(() => {
    if (
      dados.sequencialRoteiro &&
      dados.sequencialRoteiro > 0 &&
      dados.sequencialUltimaAtividadeExecutada &&
      dados.sequencialUltimaAtividadeExecutada > 0
    ) {
      const parametros = {
        sequencialRoteiro: dados.sequencialRoteiro,
        sequencialAtividade: dados.sequencialUltimaAtividadeExecutada,
        sequencialAcaoFiscal: dados.acaoFiscal,
      };

      proximasAtividadesRequest(apiRoutes.fiscalizacao.ordemservico.proximasAtividades, parametros);
    }
  }, [proximasAtividadesRequest, dados]);

  useEffect(() => {
    if (!proximasAtividadesData && !proximasAtividadesErrors) return;

    if (proximasAtividadesData) {
      setProximasAtividades(proximasAtividadesData.result);
    }

    if (proximasAtividadesErrors) toast.error(proximasAtividadesErrors.message);
  }, [proximasAtividadesData, proximasAtividadesErrors]);

  const [proximaAtividadeSelecionada, setProximaAtividadeSelecionada] = useState({});
  const handleRealizarAtividade = (_atividade) => {
    setProximaAtividadeSelecionada(_atividade);
  };
  // --- verifica contribuinte
  const carregaVerificacoes = useCallback(
    (dadosOs) => {
      requestInativoDte(apiRoutes.fiscalizacao.ordemservico.verificaContribuinte, { sqAcaoFiscal: dadosOs.acaoFiscal });
      requestInativo(apiRoutes.fiscalizacao.ordemservico.verificaInatividade, { sqAcaoFiscal: dadosOs.acaoFiscal });
    },
    [requestInativoDte, requestInativo],
  );

  useEffect(() => {
    if (dataInativoDte) {
      setEhInativoDte(dataInativoDte.result);
    }

    if (dataInativo) {
      setEhInativo(dataInativo.result);
    }
  }, [dataInativoDte, dataInativo, setEhInativoDte, setEhInativo]);

  const {
    request: consultaFormRequest,
    data: consultaFormData,
    errors: consultaFormErrors,
    isLoading: consultaFormIsLoading,
  } = useApiClient();

  const carregarOs = useCallback(
    (seq) => {
      consultaFormRequest(apiRoutes.fiscalizacao.ordemservico.consultaDadosOs, { sequencial: seq });
    },
    [consultaFormRequest],
  );

  useEffect(() => {
    carregarOs(sequencialOs);
  }, [carregarOs, sequencialOs]);

  useEffect(() => {
    if (filaAssinaturaSucessoStateKey) {
      carregarOs(sequencialOs);
    }
    return () => {
      dispatch(signalrActions.clearState("filaAssinaturaSucessoStateKey"));
    };
  }, [dispatch, carregarOs, sequencialOs, filaAssinaturaSucessoStateKey]);

  useEffect(() => {
    if ((!consultaFormData && !consultaFormErrors) || consultaFormIsLoading) return;

    if (consultaFormData) {
      setCnpjCpf(consultaFormData.result.cnpjCpf.toString());

      if (consultaFormData.result.executores === null) {
        setExecutores("");
      } else {
        setExecutores([consultaFormData.result.executores.split(", ")]);
      }

      if (consultaFormData.result.stAcaoFiscal === "A") {
        if (consultaFormData.result.diasParaExpirar < 0) {
          const diasExpirar = Math.abs(consultaFormData.result.diasParaExpirar);

          if (diasExpirar === 1) {
            setDiasParaExpirar(`Expirada (há ${diasExpirar} dia)`);
          } else {
            setDiasParaExpirar(`Expirada (há ${diasExpirar} dias)`);
          }
        } else if (
          consultaFormData.result.diasParaExpirar === 0 &&
          consultaFormData.result.dataInicialPeriodoOs === null
        ) {
          setDiasParaExpirar("-");
        } else {
          setDiasParaExpirar(consultaFormData.result.diasParaExpirar);
        }
      } else {
        setDiasParaExpirar("-");
      }

      setDataInicialFiscalizacao(formatarData(consultaFormData.result.dataInicialFiscalizacao));
      setDataFinalFiscalizacao(formatarData(consultaFormData.result.dataFinalFiscalizacao));

      if (consultaFormData.result.dataInicialPeriodoOs === null) {
        setDataInicialPeriodoOs(null);
      } else {
        setDataInicialPeriodoOs(formatarData(consultaFormData.result.dataInicialPeriodoOs));
      }

      if (consultaFormData.result.dataFinalPeriodoOs === null) {
        setDataFinalPeriodoOs(null);
      } else {
        setDataFinalPeriodoOs(formatarData(consultaFormData.result.dataFinalPeriodoOs));
      }

      if (consultaFormData.result.dataUltimaAtividadeExecutada === null) {
        setDataUltimaAtividadeExecutada(null);
      } else {
        setDataUltimaAtividadeExecutada(
          formatarData(consultaFormData.result.dataUltimaAtividadeExecutada, "dd/MM/yyyy HH:mm"),
        );
      }

      setAnexos(consultaFormData.result.anexos);
      setDados(consultaFormData.result);
      carregaVerificacoes(consultaFormData.result);
      if (
        consultaFormData.result.dsTipoAcaoFiscal === "AUDITORIA" ||
        consultaFormData.result.dsTipoAcaoFiscal === "AUDITORIA ESPECÍFICA" ||
        consultaFormData.result.dsTipoAcaoFiscal === "AUDITORIA DE BAIXA DE INSCRIÇÃO ESTADUAL"
      ) {
        setMostrarNumAuto(true);
      }
      setProdutosAcaoFiscal(consultaFormData.result.produtosAcaoFiscal ?? []);
    }

    if (consultaFormErrors) {
      toast.error(consultaFormErrors.message);
    }
  }, [consultaFormData, consultaFormErrors, consultaFormIsLoading, carregaVerificacoes]);

  useEffect(() => {
    if (cancelarIsLoading) return;

    if (!cancelarData && !cancelarErrors) return;

    if (cancelarData) {
      toast.success("Comunicado cancelado com sucesso!");
      window.location.reload();
    }
  }, [cancelarData, cancelarErrors, cancelarIsLoading]);

  const cancelarAtividade = () => {
    cancelarRequest(apiRoutes.fiscalizacao.ordemservico.cancelarAtividade, {
      sequencialAcaoFiscal: dados.acaoFiscal,
      sequencialComunicado: dados.sequencialComunicadoUltimaAtividade,
      sequencialAtividade: dados.sequencialUltimaAtividadeExecutada,
      tipoAuto: null,
    });
    setShow(false);
  };

  const { setDocParams } = useDocumentoSpf();

  documentoSpf.exibir = (dadosSpf) => {
    setDocParams({ sqAberturaProcesso: dadosSpf.sequencialProcedimentoFiscal });
  };

  const { setDocDesignaParams } = useAndamentoDesignaDocumento();

  andamentoDesignaDoc.exibir = (dadosOs) => {
    setDocDesignaParams({
      sqOrdemServico: dadosOs.sequencial,
      nuInscricaoEstadual: dadosOs.inscricaoEstadual,
      sqAcaoFiscal: dadosOs.acaoFiscal,
    });
  };

  const montarTexto = (dado) => {
    texto =
      `<p>` +
      `<b> OS Nº:</b> ${dado.sequencial} <br />` +
      `<b> Status: </b> ${dado.status} <br />` +
      `<b> Motivo: </b> ${dado.motivoCancelamentoAF ?? ""} <br />` +
      `<b> Data: </b> ${
        dado.dataCancelamentoAF ? formatarData(dado.dataCancelamentoAF, "dd/MM/yyyy HH:mm") : ""
      } <br />` +
      `<b> Usuário: </b> ${dado.nomePessoaCancelamentoAF} - ${dado.matriculaPessoaCancelamentoAF} <br />` +
      `</p>`;
    setTextoCancelamento(texto);
  };

  const [anexosSpf, setAnexosSpf] = useState([]);

  const { request: requestAnexoSpf, data: dataAnexoSpf, errors: errorsAnexoSpf } = useApiClient();

  useEffect(() => {
    const spf = { sqAberturaProcesso: dados?.sequencialProcedimentoFiscal };
    if (spf.sqAberturaProcesso) {
      requestAnexoSpf(apiRoutes.fiscalizacao.procedimentoFiscal.consultaAnexoSpf, spf);
    }
  }, [requestAnexoSpf, dados]);

  useEffect(() => {
    if (errorsAnexoSpf) return;

    if (dataAnexoSpf) {
      setAnexosSpf(dataAnexoSpf?.result);
    }
  }, [dataAnexoSpf, errorsAnexoSpf]);

  const isAnexo = anexosSpf?.length > 0;

  const sqSpf = dados.sequencialProcedimentoFiscal ? dados.sequencialProcedimentoFiscal : "-";

  const redirectAnexo = () => {
    history.push(`/app/spf/pendencias/detalhe?numSpf=${dados.sequencialProcedimentoFiscal}`);
  };

  const isCancelarAtividade = () => {
    if (
      consultarOs === 0 ||
      (consultarOs === 1 &&
        isAllowed(funcionalidades.os.executarDiretor) &&
        dados?.siglaUltimaAtividadeExecutada === "DEDIENPRAR")
    ) {
      setShow(true);
    } else {
      toast.warning("Não é permitido realizar ações na tela de Consultar OS.");
    }
  };

  return consultaFormData ? (
    <>
      <EfisModal
        show={showModal}
        title="Motivo"
        size="md"
        closeHandler={() => setShowModal(false)}
        primaryLabelVisible={false}
        secondaryLabel="Fechar"
        colorVariant="primary"
        body={<span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`${textoCancelamento}`) }} />}
      />
      <Row sm="12" lg="12">
        <Col className="p-4">
          <h2 className="mb-4">
            {`N° OS - ${dados.sequencial}`}
            {dados.binarioDocumento !== null ? (
              <FileDownloader
                binario={dados.binarioDocumento}
                tooltip={`Visualizar OS-${dados.sequencial}`}
                className="ml-2"
              />
            ) : (
              <ButtonImage
                className="btn-lg text-success p-0"
                buttonImage={<BsDownload size="16" color="#e37023" />}
                tooltipImage={`Visualizar OS-${dados.sequencial}`}
                onClick={() => andamentoDesignaDoc.exibir(dados)}
              />
            )}
          </h2>
          <Row>
            <Col sm="2" lg="2">
              <Card.Title as="strong">Inscrição Estadual</Card.Title>
            </Col>
            <Col sm="2" lg="2">
              <Card.Title as="strong">CNPJ/CPF</Card.Title>
            </Col>
            <Col sm="3" lg="3">
              <Card.Title as="strong">Razão Social</Card.Title>
            </Col>
            <Col sm="2" lg="2">
              <Card.Title as="strong">Tipo de Contribuinte</Card.Title>
            </Col>
            <Col sm="3" lg="3">
              <Card.Title as="strong">Executores</Card.Title>
            </Col>
          </Row>
          <Row className="mt-0">
            <Col sm="2" lg="2">
              <Card.Text as="p">
                {dados.inscricaoEstadual === null ? "-" : <IE value={dados.inscricaoEstadual} />}
              </Card.Text>
            </Col>
            <Col sm="2" lg="2">
              <Card.Text as="p">{cnpjCpf.length === 11 ? <CPF value={cnpjCpf} /> : <CNPJ value={cnpjCpf} />}</Card.Text>
            </Col>
            <Col sm="3" lg="3">
              <Card.Text as="p">{dados.razaoSocial}</Card.Text>
            </Col>
            <Col sm="2" lg="2">
              <Card.Text as="p">{dados.tipoContribuinte}</Card.Text>
            </Col>
            <Col sm="3" lg="3">
              <Card.Text as="p">
                {executores.length > 0 && executores[0].map((executor) => <li key={executor}>{executor}</li>)}
              </Card.Text>
            </Col>
          </Row>
          <Row className="pt-2">
            <Col sm="2" lg="2">
              <Card.Title as="strong">Período de Fiscalização</Card.Title>
            </Col>
            <Col sm="2" lg="2">
              <Card.Title as="strong">Período da OS</Card.Title>
            </Col>
            <Col sm="3" lg="3">
              <Card.Title as="strong">SPF N°</Card.Title>
            </Col>
            <Col sm="2" lg="2">
              <Card.Title as="strong">Situação IE</Card.Title>
            </Col>
            <Col sm="3" lg="3">
              <Card.Title as="strong">Diretor Atribuído</Card.Title>
            </Col>
          </Row>
          <Row>
            <Col sm="2" lg="2">
              <Card.Text as="p">{`${dataInicialFiscalizacao} a ${dataFinalFiscalizacao}`}</Card.Text>
            </Col>
            <Col sm="2" lg="2">
              <Card.Text as="p">
                {dataInicialPeriodoOs === null && dataFinalPeriodoOs === null
                  ? "-"
                  : `${dataInicialPeriodoOs} a ${dataFinalPeriodoOs}`}
              </Card.Text>
            </Col>
            <Col sm="3" lg="3">
              {isAnexo ? (
                <ButtonImage
                  className="text-primary"
                  buttonImage={dados.sequencialProcedimentoFiscal}
                  tooltipImage="SPF com Anexo(s)"
                  onClick={() => redirectAnexo()}
                />
              ) : (
                sqSpf
              )}

              {dados.sequencialProcedimentoFiscal &&
                (dados.blProcedimentoFiscalAssinado ? (
                  <FileDownloader
                    placement="top"
                    binario={dados.blProcedimentoFiscalAssinado}
                    tooltip={
                      dados.blProcedimentoFiscalAssinado
                        ? `Visualizar SPF Nº ${dados.sequencialProcedimentoFiscal}`
                        : "Não disponível"
                    }
                    disabled={!dados.blProcedimentoFiscalAssinado}
                  />
                ) : (
                  <ButtonImage
                    className="btn-lg text-success p-0"
                    buttonImage={<BsDownload size="16" color="#e37023" />}
                    tooltipImage={`Visualizar SPF Nº ${dados.sequencialProcedimentoFiscal}`}
                    onClick={() => exibirDocumento(dados)}
                  />
                ))}
            </Col>
            <Col sm="2" lg="2">
              <Card.Text as="p">{dados.situacaoInscricaoEstadual}</Card.Text>
            </Col>
            <Col sm="3" lg="3">
              <Card.Text as="p">{dados.nmDiretorAtribuido}</Card.Text>
            </Col>
          </Row>
          {dados.dataProrrogadaInicio !== "0001-01-01T00:00:00" &&
            dados.dataProrrogadaFim !== "0001-01-01T00:00:00" && (
              <>
                <Row>
                  <Col sm="2" lg="2" />
                  <Col sm="2" lg="2">
                    <Card.Title as="strong">Período da Prorrogação</Card.Title>
                  </Col>
                  <Col sm="5" lg="5" />
                  <Col sm="3" lg="3" />
                </Row>
                <Row>
                  <Col sm="2" lg="2" />
                  <Col sm="2" lg="2">
                    <Card.Text as="p">
                      {dados.dataProrrogadaInicio === null && dados.dataProrrogadaFim === null
                        ? "-"
                        : `${formatarData(dados.dataProrrogadaInicio, "dd/MM/yyyy")} a ${formatarData(
                            dados.dataProrrogadaFim,
                            "dd/MM/yyyy",
                          )}`}
                    </Card.Text>
                  </Col>
                  <Col sm="5" lg="5" />
                  <Col sm="3" lg="3" />
                </Row>
              </>
            )}
          <Row className="pt-4">
            <Col sm="2" lg="2">
              <Card.Title as="strong">Dias para Expirar</Card.Title>
            </Col>
            <Col sm="2" lg="2">
              <Card.Title as="strong">Tipo de Ação Fiscal</Card.Title>
            </Col>
            <Col sm="2" lg="2">
              <Card.Title as="strong">Status da OS</Card.Title>
            </Col>
            <Col sm="2" lg="2">
              <Card.Title as="strong">{mostrarNumAuto ? "Nº dos Autos" : ""}</Card.Title>
            </Col>
          </Row>
          <Row>
            <Col sm="2" lg="2">
              <Card.Text as="p" className="mb-4">
                <strong
                  className={
                    (diasParaExpirar >= 0 && diasParaExpirar <= 10) || diasParaExpirar.length > 8 ? "text-danger" : ""
                  }
                >
                  {diasParaExpirar}
                </strong>
              </Card.Text>
            </Col>
            <Col sm="2" lg="2">
              <Card.Text as="p" className="mb-4">
                {dados.dsTipoAcaoFiscal}
              </Card.Text>
            </Col>
            <Col sm="2" lg="2">
              <Card.Text as="p">
                {dados.status}
                {dados.status === "Cancelada" && (
                  <ButtonImage
                    className="btn-md btnOrange pa-0 p-0 px-1"
                    buttonImage={<BsFillEyeFill />}
                    tooltipImage="Ver motivo do cancelamento"
                    onClick={() => {
                      setShowModal(true);
                      montarTexto(dados);
                    }}
                  />
                )}
              </Card.Text>
            </Col>

            <Col sm="2" lg="2">
              <Card.Text as="p">
                {produtosAcaoFiscal.length > 0 &&
                  produtosAcaoFiscal.map((produto) => (
                    <li key={produto}>{produto.numeroProdutoAcaoFiscal.substring(4, 13)}</li>
                  ))}
              </Card.Text>
            </Col>
          </Row>
        </Col>
      </Row>
      {(ehInativo === "S" || ehInativoDte === "S") && (
        <Row>
          <Col sm="12" lg="8">
            <Card.Text as="p" className="mb-4">
              <span className="text-danger" style={{ fontSize: 14 }}>
                {ehInativoDte === "S"
                  ? "- Nenhum documento será enviado automaticamente ao DTE do contribuinte, " +
                    "pois sua inatividade é anterior ao início do DTE. "
                  : ehInativo === "S" &&
                    "- Não será realizada a ciência tácita dos documentos enviados ao DTE do contribuinte, pois ele está inativo."}
              </span>
            </Card.Text>
          </Col>
        </Row>
      )}
      <Row sm="12">
        <Col>
          <Card>
            <Card.Body>
              <Row>
                <Col className="mb-4">
                  <Tabs id="controlled-tab-example" defaultActiveKey="1.0" activeKey={key} onSelect={(k) => setKey(k)}>
                    <Tab className="pl-1" eventKey="1.0">
                      <h5>Principal</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="1.1">
                      <h5>Principal - OS</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="1.2">
                      <h5>Principal - Andamento</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="1.3">
                      <h5>Principal - Auto de Infração</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="2.1">
                      <h5>Dossiê Contribuinte - Extrato Fiscal</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="2.2">
                      <h5>Dossiê Contribuinte - SPED</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="2.3">
                      <h5>Dossiê Contribuinte - Cadastro</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="2.4">
                      <h5>Dossiê Contribuinte - Outras Ações Fiscais</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="2.5">
                      <h5>Dossiê Contribuinte - PAT Existentes</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="2.6">
                      <h5>Dossiê Contribuinte - Ocorrência REFC </h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="2.7">
                      <h5>Dossiê Contribuinte - Parte de Serviço</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="3.1">
                      <h5>Outros Procedimentos - Prorrogação de OS</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="3.2">
                      <h5>Outros Procedimentos - Alteração de Executor</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="3.3">
                      <h5>Outros Procedimentos - Parte de Serviço</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="3.4">
                      <h5>Outros Procedimentos - Auto de Infração Especial</h5>
                    </Tab>
                    <Tab className="pl-1" eventKey="3.5">
                      <h5>Outros Procedimentos - Termo de Sujeição Passiva Solidária</h5>
                    </Tab>
                  </Tabs>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Nav variant="pills" activeKey="1" onSelect={handleSelect}>
                    <NavDropdown title="Principal" id="nav-dropdown">
                      <NavDropdown.Item eventKey="1.1">Execução</NavDropdown.Item>
                      <NavDropdown.Item eventKey="1.2">Andamento</NavDropdown.Item>
                      <NavDropdown.Item eventKey="1.3" disabled>
                        Auto de Infração
                      </NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title="Outros Procedimentos" id="nav-dropdown">
                      <NavDropdown.Item eventKey="3.1">Prorrogação de OS</NavDropdown.Item>
                      <NavDropdown.Item eventKey="3.2">Alteração de Executor</NavDropdown.Item>
                      <NavDropdown.Item eventKey="3.3">Parte de Serviço</NavDropdown.Item>
                      <NavDropdown.Item eventKey="3.4" disabled>
                        Auto de Infração Especial
                      </NavDropdown.Item>
                      <NavDropdown.Item eventKey="3.5" disabled>
                        Termo de Sujeição Passiva Solidária
                      </NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title="Dossiê Contribuinte" id="nav-dropdown">
                      <NavDropdown.Item eventKey="2.3">Cadastro</NavDropdown.Item>
                      <NavDropdown.Item eventKey="2.4">Outras Ações Fiscais</NavDropdown.Item>
                      <NavDropdown.Item eventKey="2.5">PAT Existentes</NavDropdown.Item>
                      <NavDropdown.Item eventKey="2.1">Extrato Fiscal</NavDropdown.Item>
                      <NavDropdown.Item eventKey="2.2">SPED</NavDropdown.Item>
                      <NavDropdown.Item eventKey="2.6">Ocorrência REFC</NavDropdown.Item>
                      <NavDropdown.Item eventKey="2.7">Parte de Serviço</NavDropdown.Item>
                    </NavDropdown>
                  </Nav>
                </Col>
              </Row>

              {key === "1.2" && (
                <Row style={{ paddingTop: 30 }}>
                  <Col>
                    <div className="card-header pt-3 pb-0 flex-row w-100">
                      <Form.Group as={Row} className="d-flex flex-row">
                        <Col sm="12" style={{ marginBottom: 15 }} className="form-inline justify-content-end">
                          {!consultaFormIsLoading && (
                            <AndamentoOs
                              numOs={dados.acaoFiscal}
                              sqOs={dados.sequencial}
                              inscEstadual={dados.inscricaoEstadual}
                            />
                          )}
                        </Col>
                      </Form.Group>
                    </div>
                  </Col>
                </Row>
              )}

              {(key === "1.1" || key === "1.0") && (
                <Row className="mt-4">
                  <Col>
                    <Tabs id="controlled-tab-example" className="mb-3">
                      {isAllowed(funcionalidades.os.consultaDadosAtividades) ? (
                        <Tab eventKey="1.1" title="Atividades">
                          <FormAlert
                            formik={dados}
                            data={cancelarData}
                            errors={cancelarErrors}
                            isLoading={cancelarIsLoading}
                            dismissible
                          />
                          <EfisModal
                            show={show}
                            title="Atenção!"
                            size="md"
                            closeHandler={() => setShow(false)}
                            loadingConfirmationAction={cancelarIsLoading}
                            confirmationHandler={() => cancelarAtividade()}
                            primaryLabel="Sim"
                            secondaryLabel="Não"
                            body="Confirma o cancelamento da atividade?"
                          />
                          <p>
                            <strong>Última Atividade Realizada</strong>
                            <br />
                            {dados.ultimaAtividadeExecutada === null ? (
                              "-"
                            ) : (
                              <>
                                <span className="text-primary">{dados.ultimaAtividadeExecutada}</span>
                                {dados.doc_Atividade !== null && (
                                  <FileDownloader
                                    binario={dados.doc_Atividade}
                                    tooltip="Abrir documento"
                                    className="ml-2"
                                  />
                                )}
                                <OverlayTrigger placement="top" overlay={<Tooltip>Cancelar</Tooltip>}>
                                  <CgUndo
                                    className="btn-lg text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
                                    onClick={() => isCancelarAtividade()}
                                  />
                                </OverlayTrigger>
                              </>
                            )}
                            <br />
                            (<CPF value={dados.documentoUltimaAtividadeExecutada} />
                            {` - ${dados.usuarioUltimaAtividadeExecutada} - ${dataUltimaAtividadeExecutada})`}
                          </p>

                          {!dados?.sequencialComunicado && dados?.origemEfis === "S" && (
                            <Dropdown className="mt-4 mb-4">
                              <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
                                Realizar Atividade
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {proximasAtividades?.length > 0 ? (
                                  proximasAtividades.map((_atividade) => {
                                    const itemMenu = (
                                      <Dropdown.Item onClick={() => handleRealizarAtividade(_atividade)}>
                                        {_atividade.nomeAtividade}
                                      </Dropdown.Item>
                                    );
                                    if (
                                      ehInativoDte === "S" &&
                                      (dados.siglaTipoAcaoFiscal === "AUDITORIA" ||
                                        dados.siglaTipoAcaoFiscal === "DILIGENCIA" ||
                                        dados.siglaTipoAcaoFiscal === "BAIXA")
                                    ) {
                                      if (
                                        _atividade.siglaAtividade === "I1" ||
                                        _atividade.siglaAtividade === "I2" ||
                                        _atividade.siglaAtividade === "I3" ||
                                        _atividade.siglaAtividade === "IF1" ||
                                        _atividade.siglaAtividade === "IF2" ||
                                        _atividade.siglaAtividade === "IF3"
                                      ) {
                                        return null; // Essas atividades serão agrupadas nos submenus abaixo
                                      }
                                    }
                                    return itemMenu;
                                  })
                                ) : (
                                  <span className="m-0 font-weight-bold text-primary flex-grow-1 px-2">
                                    Nenhuma atividade para o usuário logado
                                  </span>
                                )}

                                {/* Submenu para as atividades 'IF1', 'IF2' e 'IF3' */}
                                {ehInativoDte === "S" &&
                                  (dados.siglaTipoAcaoFiscal === "AUDITORIA" ||
                                    dados.siglaTipoAcaoFiscal === "DILIGENCIA" ||
                                    dados.siglaTipoAcaoFiscal === "BAIXA") &&
                                  proximasAtividades?.some(
                                    (_atividade) =>
                                      _atividade.siglaAtividade === "IF1" ||
                                      _atividade.siglaAtividade === "IF2" ||
                                      _atividade.siglaAtividade === "IF3",
                                  ) && (
                                    <Dropdown className="no-arrow">
                                      <Dropdown.Toggle size="md" variant="" id="dropdown-basic">
                                        Termo de Intimação Fiscal
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu>
                                        {proximasAtividades?.length > 0 ? (
                                          proximasAtividades.map((_atividade) => {
                                            if (
                                              _atividade.siglaAtividade === "IF1" ||
                                              _atividade.siglaAtividade === "IF2" ||
                                              _atividade.siglaAtividade === "IF3"
                                            ) {
                                              return (
                                                <Dropdown.Item onClick={() => handleRealizarAtividade(_atividade)}>
                                                  {_atividade.nomeAtividade}
                                                </Dropdown.Item>
                                              );
                                            }
                                            return null; // As atividades 'I1', 'I2' e 'I3' já estão no submenu, não precisamos repeti-las aqui
                                          })
                                        ) : (
                                          <span className="m-0 font-weight-bold text-primary flex-grow-1 px-2">
                                            Nenhuma atividade para o usuário logado
                                          </span>
                                        )}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  )}
                                {/* Submenu para as atividades 'I1', 'I2' e 'I3' */}
                                {ehInativoDte === "S" &&
                                  (dados.siglaTipoAcaoFiscal === "AUDITORIA" ||
                                    dados.siglaTipoAcaoFiscal === "DILIGENCIA" ||
                                    dados.siglaTipoAcaoFiscal === "BAIXA") &&
                                  proximasAtividades?.some(
                                    (_atividade) =>
                                      _atividade.siglaAtividade === "I1" ||
                                      _atividade.siglaAtividade === "I2" ||
                                      _atividade.siglaAtividade === "I3",
                                  ) && (
                                    <Dropdown className="no-arrow">
                                      <Dropdown.Toggle size="md" variant="" id="dropdown-basic">
                                        Termo de Início de Fiscalização
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu>
                                        {proximasAtividades?.length > 0 ? (
                                          proximasAtividades.map((_atividade) => {
                                            if (
                                              _atividade.siglaAtividade === "I1" ||
                                              _atividade.siglaAtividade === "I2" ||
                                              _atividade.siglaAtividade === "I3"
                                            ) {
                                              return (
                                                <Dropdown.Item onClick={() => handleRealizarAtividade(_atividade)}>
                                                  {_atividade.nomeAtividade}
                                                </Dropdown.Item>
                                              );
                                            }
                                            return null;
                                          })
                                        ) : (
                                          <span className="m-0 font-weight-bold text-primary flex-grow-1 px-2">
                                            Nenhuma atividade para o usuário logado
                                          </span>
                                        )}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  )}
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                          <InputsProximaAtividadeBase
                            dadosOs={dados}
                            atividade={
                              proximaAtividadeSelecionada.sequencialAtividade
                                ? proximaAtividadeSelecionada
                                : _.find(
                                    proximasAtividades,
                                    (atividade) =>
                                      atividade.sequencialAtividade === dados?.sequencialAtividadeComunicado,
                                  )
                            }
                            anexos={anexos.filter((anexo) => anexo.sequencialComunicado === dados.sequencialComunicado)}
                          />
                        </Tab>
                      ) : null}

                      {isAllowed(funcionalidades.ocorrencia.consultaDadosOcorrencias) ? (
                        <Tab eventKey="1.2" title="Ocorrências">
                          <Row style={{ paddingTop: 30 }}>
                            <Col>
                              <div className="card-header pt-3 pb-0 flex-row w-100">
                                <Form.Group as={Row} className="d-flex flex-row">
                                  <Col sm="12" style={{ marginBottom: 15 }}>
                                    {!consultaFormIsLoading &&
                                    dados.siglaTipoAcaoFiscal !== "ROTDIL" &&
                                    dados.siglaTipoAcaoFiscal !== "MONIT" ? (
                                      <ConsultaOcorrenciaAF dadosOs={dados} history={history} />
                                    ) : (
                                      <div className="alert alert-danger" style={{ marginTop: 30 }} role="alert">
                                        {" "}
                                        Esse tipo de ação fiscal não admite ocorrências.
                                      </div>
                                    )}
                                  </Col>
                                </Form.Group>
                              </div>
                            </Col>
                          </Row>
                        </Tab>
                      ) : (
                        <div className="alert alert-danger" style={{ marginTop: 30 }} role="alert">
                          Você não tem permissão para acessar a consulta de ocorrências da ação fiscal.
                        </div>
                      )}
                      {isAllowed(funcionalidades.os.consultaDadosAnexos) ? (
                        <Tab eventKey="2.2" title="Anexos">
                          <ConsultaAnexos
                            sqAcaoFiscal={dados.acaoFiscal}
                            sqOrdemServico={dados.sequencial}
                            sqComunicado={dados.sequencialComunicado}
                            sqAtividade={dados.sequencialAtividadeComunicado}
                            permissao
                            anexosOs
                          />
                        </Tab>
                      ) : null}
                    </Tabs>
                  </Col>
                </Row>
              )}
              {key === "2.1" &&
                (isAllowed(funcionalidades.extratoFiscal.consultar) ? (
                  <Row style={{ paddingTop: 30 }}>
                    <Col>
                      <div className="card-header pt-3 pb-0 flex-row w-100">
                        <Form.Group as={Row} className="d-flex flex-row">
                          <Col sm="12" style={{ marginBottom: 15 }}>
                            <ExtratoFiscal dadosOs={dados} />
                          </Col>
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="alert alert-danger" style={{ marginTop: 50 }} role="alert">
                    Você não tem permissão para acessar o extrato fiscal.
                  </div>
                ))}
              {key === "2.2" &&
                (isAllowed(funcionalidades.ordemservico.consultar) ? (
                  <Row style={{ paddingTop: 30 }}>
                    <Col>
                      <div className="card-header pt-3 pb-0 flex-row w-100">
                        <Form.Group as={Row} className="d-flex flex-row">
                          <Col sm="12" style={{ marginBottom: 15 }}>
                            <ConsultaSped dadosOs={dados} />
                          </Col>
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="alert alert-danger" style={{ marginTop: 50 }} role="alert">
                    Você não tem permissão para acessar outras ações fiscais.
                  </div>
                ))}
              {key === "2.3" &&
                (isAllowed(funcionalidades.ordemservico.consultar) ? (
                  <Row style={{ paddingTop: 30 }}>
                    <Col>
                      <div className="card-header pt-3 pb-0 flex-row w-100">
                        <Form.Group as={Row} className="d-flex flex-row">
                          <Col sm="12" style={{ marginBottom: 15 }}>
                            <ConsultaContribuinte dadosOs={dados} />
                          </Col>
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="alert alert-danger" style={{ marginTop: 50 }} role="alert">
                    Você não tem permissão para acessar outras ações fiscais.
                  </div>
                ))}
              {key === "2.4" &&
                (isAllowed(funcionalidades.ordemservico.consultar) ? (
                  <Row style={{ paddingTop: 30 }}>
                    <Col>
                      <div className="card-header pt-3 pb-0 flex-row w-100">
                        <Form.Group as={Row} className="d-flex flex-row">
                          <Col sm="12" style={{ marginBottom: 15 }} className="form-inline justify-content-end">
                            <OutrasAcoesFiscais dadosOs={dados} />
                            {/* {!consultaFormIsLoading && <AlteracaoExecutorOs dadosOs={dados} />} */}
                          </Col>
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="alert alert-danger" style={{ marginTop: 50 }} role="alert">
                    Você não tem permissão para acessar outras ações fiscais.
                  </div>
                ))}

              {key === "2.5" &&
                (isAllowed(funcionalidades.ordemservico.consultar) ? (
                  <Row style={{ paddingTop: 30 }}>
                    <Col>
                      <div className="card-header pt-3 pb-0 flex-row w-100">
                        <Form.Group as={Row} className="d-flex flex-row">
                          <Col sm="12" style={{ marginBottom: 15 }} className="form-inline justify-content-end">
                            <PatExistente dadosOs={dados} />
                          </Col>
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="alert alert-danger" style={{ marginTop: 50 }} role="alert">
                    Você não tem permissão para acessar outras ações fiscais.
                  </div>
                ))}

              {key === "2.6" &&
                (isAllowed(funcionalidades.ordemservico.consultar) ? (
                  <Row style={{ paddingTop: 30 }}>
                    <Col>
                      <div className="card-header pt-3 pb-0 flex-row w-100">
                        <Form.Group as={Row} className="d-flex flex-row">
                          <Col sm="12" style={{ marginBottom: 15 }}>
                            <ConsultaRefc dadosOs={dados} />
                          </Col>
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="alert alert-danger" style={{ marginTop: 50 }} role="alert">
                    Você não tem permissão para acessar as ocorrências.
                  </div>
                ))}
              {key === "2.7" &&
                (isAllowed(funcionalidades.parteServico.consultar) ? (
                  <Row style={{ paddingTop: 30 }}>
                    <Col>
                      <div className="card-header pt-3 pb-0 flex-row w-100">
                        <Form.Group as={Row} className="d-flex flex-row">
                          <Col sm="12" style={{ marginBottom: 15 }}>
                            <ParteServicoPaginatedView
                              title="Parte de Serviço"
                              keyField="sqParteServico"
                              descriptionField="sqParteServico"
                              defaultSearch
                              defaultSearchPlaceholder="N° Parte de Serviço"
                              advancedSearchFormik={formik}
                              queryService={apiRoutes.fiscalizacao.parteservico.listaParteServicoPv}
                              editRoute="/app/parteservico/form"
                              columns={columns}
                              history={history}
                              reduxKey="parteServico"
                              buttonTitle="Nova Parte de Serviço"
                              sqAcaoFiscal={dados.acaoFiscal}
                              origem="dossie"
                            />
                          </Col>
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="alert alert-danger" style={{ marginTop: 50 }} role="alert">
                    Você não tem permissão para acessar as ocorrências.
                  </div>
                ))}
              {key === "3.1" &&
                (isAllowed(funcionalidades.os.ProrrogacaoConsultar) ? (
                  <Row style={{ paddingTop: 30 }}>
                    <Col>
                      <div className="card-header pt-3 pb-0 flex-row w-100">
                        <Form.Group as={Row} className="d-flex flex-row">
                          <Col sm="12" style={{ marginBottom: 15 }}>
                            {!consultaFormIsLoading && (
                              <ProrrogacaoOs
                                dadosOs={dados}
                                atividade={proximaAtividadeSelecionada}
                                diasExpirar={dados.diasParaExpirar}
                                history={history}
                              />
                            )}
                          </Col>
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="alert alert-danger" style={{ marginTop: 50 }} role="alert">
                    Você não tem permissão para acessar Prorrogação de OS.
                  </div>
                ))}

              {key === "3.2" &&
                (isAllowed(funcionalidades.ordemservico.alterarExecutorConsultar) ? (
                  <Row style={{ paddingTop: 30 }}>
                    <Col>
                      <div className="card-header pt-3 pb-0 flex-row w-100">
                        <Form.Group as={Row} className="d-flex flex-row">
                          <Col sm="12" style={{ marginBottom: 15 }}>
                            {/* className="form-inline justify-content-end" */}
                            {!consultaFormIsLoading && <AlteracaoExecutorOs dadosOs={dados} history={history} />}
                          </Col>
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="alert alert-danger" style={{ marginTop: 50 }} role="alert">
                    Você não tem permissão para acessar alteração de executor.
                  </div>
                ))}
              {key === "3.4" &&
                (isAllowed(funcionalidades.autoInfracaoEspecial.consultar) ? (
                  <Row style={{ paddingTop: 30 }}>
                    <Col>
                      <div className="card-header pt-3 pb-0 flex-row w-100">
                        <Form.Group as={Row} className="d-flex flex-row">
                          <Col sm="12" style={{ marginBottom: 15 }}>
                            {!consultaFormIsLoading && <AutoInfracaoEspecial dadosOs={dados} />}
                          </Col>
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="alert alert-danger" style={{ marginTop: 50 }} role="alert">
                    Você não tem permissão para acessar Auto de Infração Especial.
                  </div>
                ))}

              {key === "3.5" &&
                (isAllowed(funcionalidades.ordemservico.tsps) ? (
                  <Row style={{ paddingTop: 30 }}>
                    <Col>
                      <div className="card-header pt-3 pb-0 flex-row w-100">
                        <Col sm="12" style={{ marginBottom: 15 }}>
                          {!consultaFormIsLoading && <TSPS dadosOs={dados} />}
                        </Col>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="alert alert-danger" style={{ marginTop: 50 }} role="alert">
                    Você não tem permissão para acessar alteração de executor.
                  </div>
                ))}

              {key === "3.3" &&
                (isAllowed(funcionalidades.os.executar) ? (
                  <Row style={{ paddingTop: 30 }}>
                    <Col>
                      <div className="card-header pt-3 pb-0 flex-row w-100">
                        <Form.Group as={Row} className="d-flex flex-row">
                          <Col sm="12" style={{ marginBottom: 15 }} className="form-inline justify-content-end">
                            {!consultaFormIsLoading && (
                              <ParteServicoOs location={location} history={history} dadosOs={dados} />
                            )}
                          </Col>
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="alert alert-danger" style={{ marginTop: 50 }} role="alert">
                    Você não tem permissão para acessar a Parte de Serviço.
                  </div>
                ))}

              <Row style={{ marginTop: "30px" }}>
                <Col sm="2">
                  <Button
                    variant="danger"
                    onClick={() =>
                      history.push({
                        pathname: consultarOs === 1 ? "/app/os/consultarOs" : "/app/os/executarOs",
                        state: history.location.pathname,
                      })
                    }
                  >
                    Voltar
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  ) : (
    <span>
      <Spinner animation="border" role="status" />
      &nbsp;Carregando...
    </span>
  );
};

export default ConsultaDadosOs;
